// extracted by mini-css-extract-plugin
export default {"Search":"Search_Search__-3y06"};